// bao migrate skip c5a58946
import TabController from "./app-tab-controller";
import TabPage from "./../factories/tab-page";
import hasher from "hasher";
import crossroads from "crossroads";

export interface IBaoRoute {
    url?: string;
    objectId?: string;
    closable?: boolean;
    replaceRoute?: string;
    content?: string;
    title?: string;
    jsUrl?: string;
    jsFn?: string;
}
export class BaoRouter {

    public setHash = hasher.setHash;
    public getHash = hasher.getHash;
    public replaceHash = hasher.replaceHash;

    private addRoute = crossroads.addRoute;
    private routes = {
        'document/{id}': {
            url: 'BaoDocument'
        },
        'document/zip/{fileName}/{id}': {
            url: 'BaoDocument'
        },
        'search': {
            url: 'Search',
            objectId: 'Search',
            closable: false
        },
        'search/{searchkey}': {
            url: 'Search',
            objectId: 'Search',
            closable: false
        },
        'search/{searchkey}/{searchtext}': {
            url: 'Search',
            objectId: 'Search',
            closable: false
        },
        'explorer/{explorertype}': {
            url: 'Explorer',
            closable: true,
            replaceRoute: 'explorer/{explorertype}/{id}'
        },
        'explorer/{explorertype}/{id}': {
            url: 'Explorer',
            closable: true
        },
        'SystemMessage': {
            url: 'SystemMessage',
            closable: true,
            replaceRoute: 'SystemMessage/{id}'
        },
        'SystemMessage/{id}': {
            url: 'SystemMessage',
            closable: true
        },
        'jobmanagement/': {
            url: 'JobManagement',
            replaceRoute: 'instruction/{id}'
        },
        'jobmanagement/{id}': {
            url: 'JobManagement'
        },
        'baoconnector/': {
            url: 'BaoConnector',
            replaceRoute: 'baoconnector/{id}'
        },
        'baoconnector/{id}': {
            url: 'BaoConnector'
        },
        'UniversalImport': {
            url: 'UniversalImport',
            objectId: 'UniversalImport',
            closable: true
        },
        'usertaggingoverview': {
            url: 'UserTaggingOverview',
            objectId: 'UserTaggingOverview'
        }
    };
    private crossRoadsRoutes = {};
    private routedEvents = [];

    constructor() {
        const self = this;
        crossroads.routed.add(function (request, data) {
            const params = [request, data].concat(Array.prototype.slice.call(data.params, 0));
            self.routing.apply(this, params);
        });
    }

    public _parseHash(newHash, oldHash) {
        setTimeout(function () {
            crossroads.parse(newHash);
        }, 0);
    }

    public fillParams(tabPage, hash) {
        if (hash != null && tabPage != null && tabPage.Route != null && tabPage.Route.data != null &&
            tabPage.Route.data.route != null && tabPage.Route.data.params != null) {
            for (var i = 0; i < tabPage.Route.data.params.length; i++) {
                var paramKey = tabPage.Route.data.route._paramsIds[i];
                hash = hash.replace("{" + paramKey + "}", tabPage.Route.data.params[i]);
            }
        }
        return hash;
    }
    public getRouteValue(paramName, tabPage) {
        if (tabPage != null && tabPage.Route != null && tabPage.Route.data != null &&
            tabPage.Route.data.route != null && tabPage.Route.data.params != null) {
            var paramIndex;
            for (var i = 0; i < tabPage.Route.data.route._paramsIds.length; i++) {
                if (tabPage.Route.data.route._paramsIds[i] == paramName) {
                    paramIndex = i;
                    break;
                }
            }
            if (paramIndex != null) {
                return tabPage.Route.data.params[paramIndex];
            }
        }
        return null;
    }
    public routed = (fn) => {
        this.routedEvents.push(fn);
        return fn;
    };
    public unsubscribe = (fn) => {
        for (var i = 0; i < this.routedEvents.length; i++) {
            this.routedEvents[i] == fn;
            this.routedEvents.splice(i, 1);
        }
    };
    public routing = (request, data, id) => {
        var route = this.routes[data.route._pattern];
        if (route != null) {
            var urlData: any = {};
            for (var i = 0; i < data.route._paramsIds.length; i++) {
                urlData[data.route._paramsIds[i]] = data.params[i];
            }
            // if url is set, call this default behaviour
            if (route.url != null) {
                var tabPage;
                var isNewTab = false;
                if (urlData.id != null && route.url != null) {
                    tabPage = TabController.SearchTabByObjectIdUrl(urlData.id, route.url);
                }
                if (tabPage == null && route.objectId != null && route.url != null) {
                    tabPage = TabController.SearchTabByObjectIdUrl(route.objectId, route.url);
                }
                if (tabPage == null) {
                    isNewTab = true;
                    tabPage = new TabPage();
                    if (route.title != null) {
                        tabPage.Title(route.title);
                    } else {
                        tabPage.Title("loading");
                    }
                    tabPage.IsLoading(true);
                    if (route.url == null && route.content != null) {
                        tabPage.ContentLoadedDefault([{ Message: route.content }], null);
                    }
                    tabPage.Url(route.url);
                    if (route.closable != null) {
                        tabPage.IsClosable(route.closable);
                    }
                }
                tabPage.Route = {
                    data: data,
                    request: request,
                    details: route
                };
                tabPage.UrlData(urlData);
                tabPage.InitRoute(data.route._pattern);
                var idValue = this.getRouteValue("id", tabPage);
                if (idValue != null) {
                    tabPage.ObjectId(idValue);
                }
                if (route.objectId != null) {
                    tabPage.ObjectId(route.objectId);
                }
                if (isNewTab) {
                    TabController.AddTab(tabPage);
                }
                else {
                    TabController.SelectTab(tabPage);
                }
                for (var i = 0; i < this.routedEvents.length; i++) {
                    this.routedEvents[i](tabPage);
                }
                // if url is not set and jsUrl is set, call the given js function
            }
            else if (route.jsUrl != null && route.jsFn != null) {
                window.baorequire([route.jsUrl], function (jsService) {
                    jsService[route.jsFn](route, urlData);
                });
            }
        }
    };
    public findRoute = (route: string) => {
        var result = [];
        if (route != null && route.substr(0, 1) == "#") {
            route = route.substr(1);
        }
        if (route != null && this.crossRoadsRoutes != null) {
            for (var k in this.crossRoadsRoutes) {
                var r = this.crossRoadsRoutes[k];
                if (r.match(route)) {
                    var baoRouterRoute = this.routes[r._pattern];
                    if (baoRouterRoute != null) {
                        result.push(baoRouterRoute);
                    }
                }
            }
        }
        return result;
    };

    public addRoutes(routes: { [route: string]: IBaoRoute }) {
        for (const r in routes) {
            this.crossRoadsRoutes[r] = crossroads.addRoute(r);
            this.routes[r] = routes[r];
        }
    }

    public init = (initRoutes?: { [route: string]: IBaoRoute }) => {
        this.addRoutes(this.routes);
        if (initRoutes != null) {
            this.addRoutes(initRoutes);
        }
        crossroads.ignoreState = true;
        hasher.initialized.add(this._parseHash);
        hasher.changed.add(this._parseHash);
        hasher.init();
    }
}
export default new BaoRouter();